module.exports = __webpack_public_path__ + "static/media/NebraskaMedicine.fcfe2c8a.png";